import React from 'react';
import SafeIcon from '../common/SafeIcon';
import { FiLinkedin, FiInstagram, FiYoutube } from '../common/Icons';

const Footer = () => {
  return (
    <footer className="bg-slate-950 text-white pt-20 pb-10">
      <div className="container mx-auto px-6">
        <div className="flex flex-col md:flex-row justify-between items-start mb-16 gap-12">
          <div className="max-w-md">
            <div className="flex items-center space-x-3 mb-6">
              <img src="https://i.imghippo.com/files/HWKq2787aqg.png" alt="Andrea Zuccarini Logo" className="h-12 w-auto object-contain" />
              <span className="text-2xl font-black tracking-tighter">ANDREA<span className="text-orange-500 italic">ZUCCARINI</span></span>
            </div>
            <p className="text-slate-400 leading-relaxed mb-8 font-medium">Il futuro del business è scritto nel codice. Andrea Zuccarini aiuta gli imprenditori italiani a decifrarlo attraverso l'Intelligenza Artificiale applicata.</p>
            <div className="flex space-x-4">
              {[
                { icon: FiLinkedin, url: "#" },
                { icon: FiInstagram, url: "https://www.instagram.com/andrea.zuccarini/" },
                { icon: FiYoutube, url: "#" }
              ].map((social, i) => (
                <a key={i} href={social.url} target="_blank" rel="noopener noreferrer" className="w-12 h-12 bg-white/5 rounded-xl flex items-center justify-center hover:bg-orange-500 transition-all group">
                  <SafeIcon icon={social.icon} className="w-5 h-5 group-hover:scale-110 transition-transform" />
                </a>
              ))}
            </div>
          </div>
          
          <div className="grid grid-cols-2 md:grid-cols-3 gap-12">
            <div>
              <h4 className="font-black uppercase text-xs tracking-widest text-orange-500 mb-6 italic">Legale</h4>
              <ul className="space-y-4 text-slate-400 text-sm font-bold">
                <li><a href="#" className="hover:text-white transition-colors">Privacy Policy</a></li>
                <li><a href="#" className="hover:text-white transition-colors">Cookie Policy</a></li>
                <li><a href="#" className="hover:text-white transition-colors">Termini & Condizioni</a></li>
              </ul>
            </div>
          </div>
        </div>
        
        <div className="border-t border-white/5 pt-10 flex flex-col md:flex-row justify-between items-center gap-6">
          <p className="text-slate-500 text-xs font-bold uppercase tracking-widest text-center md:text-left">© 2024 Andrea Zuccarini AI Consulting. Tutti i diritti riservati.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;